export default __webpack_public_path__ + "static/media/circle-arrow-right-regular.a010afb7.svg";